module.exports = __webpack_public_path__ + "media/dashboard/assets/images/flow-new/menu-icon-content-d01463c807ee39c7b5556bf5dd082d7e.svg";